//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "CaroQuery",
	props: {
		query: String,
		setQuery: Function,
		sort: Object,
		setSort: Function,
		results: Object,
		executeSearch: Function,
		currentResultsStart: Number,
		currentResultsEnd: Number,
	},
	data() {
		return {
		};
	},
	// watch: {
	// 	query() {
	// 		if (this.query.trim().length > 3) {
	// 			fetch(this.options.keywordsEndpoint, {
	// 				method: 'post',
	// 				body: JSON.stringify(this.query.trim())
	// 			})
	// 			.then(response => response.json())
	// 			.then(data => {
	// 				this.keywords = data.results;
	// 			})
	// 			.catch((error) => {
	// 				console.error('Error:', error);
	// 			});
	// 		}
	// 	}
	// },
	computed: {
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				this.setQuery(val);
			},
		},
	},
};
